import { IAppConfiguration } from "../cemexng2components/components/app-configuration";

export default [
  {
    feature: "document-center.reference-upload-es",
    country: ["ES", "LV"],
    role_any:
      "ARMORGAPC, ARMORGARCADV,ARMORGRECONCILE,ARMORGLIEN,ARMORGAPS,ARMORGARU,ARMORGCASH,ARMSTAFFARC,ARMSTAFFDM,ARMSTAFFSR,ARMSTAFFSRCEMENT,ARMSTAFFSRM,ARMSTAFFSRMCEMENT,ARMSTAFFSCONF,Application,OPC_FORMAN,OPC_PO_MGR,OPC_CUST_OWNER",
  },
  {
    feature: "document-center.preview",
    role_any:
      "ARMORGAPC, ARMORGARCADV,ARMORGRECONCILE,ARMORGLIEN,ARMORGAPS,ARMORGARU,ARMORGCASH,ARMSTAFFARC,ARMSTAFFDM,ARMSTAFFSR,ARMSTAFFSRCEMENT,ARMSTAFFSRM,ARMSTAFFSRMCEMENT,ARMSTAFFSCONF,Application,OPC_FORMAN,OPC_PO_MGR,OPC_CUST_OWNER,ARMSTAFFAPC",
  },
  {
    feature: "document-center.enable-delete",
    excludes: {
      country: ["AE"],
    },
  },
  {
    feature: "document-center.goods-receipt",
    role_any: ["ARMORGGOODRECEIPT", "ARMSTAFFGOODRECEIPT"],
  },
  {
    feature: 'financial-documents.all-documents-tab',
    country: ['PH'],
    role_any: ['SUPVSR_DOCCENTER']
  },
  {
    feature: "document-center.goods-receipt.table-document-number",
    country: [
      "MX",
      "CO",
      "GB",
      "DE",
      "FR",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "IL",
      "PE",
      "GT",
      "DO",
      "PR",
      "PE",
      "PH",
      "PL",
      "CZ",
      "AE",
    ],
    options: {
      referenceNumber: true,
      invoiceNumber: false,
    },
  },
  {
    feature: "document-center.goods-receipt.table-document-number",
    country: ["US"],
    options: {
      referenceNumber: false,
      invoiceNumber: true,
    },
  },
  {
    feature: "document-center.goods-receipt.disableEditNotInvoiced",
    country: ["US"],
  },
  {
    feature: "document-center.delivery-ticket-report",
    country: [""],
  },
  {
    feature: "document-center.tab-delivery-ticket-report",
    country: [
      "MX",
      "US",
      "CO",
      "DE",
      "FR",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "IL",
      "PE",
      "GT",
      "DO",
      "PR",
      "PH",
      "EG",
      "GB",
      "AE",
      "CZ",
    ],
    in_rollout: true,
  },
  {
    feature: "document-center.relocate-invoice-download",
    country: ["IL"]
  },
  {
    feature: "document-center.goods-receipt.columns_order",
    country: [
      "GB",
      "DE",
      "FR",
      "PL",
      "CZ",
      "ES",
      "IL"
    ]
  },
  {
    feature: 'document-center.goods-receipt.table-template',
    country: [
      'MX',
      'CO',
      'GB',
      'DE',
      'PA',
      'CR',
      'NI',
      'SV',
      'PR',
      'PE',
      'PH',
      'PL',
      'ES',
      'LV',
      'CZ',
      'FR',
      'EG'
    ],
    options: {
      columns: {
        active: [
          'deliveryNumber',
          'POD',
          'deliveryDate',
          'products',
          'salesOrder',
          'jobSiteDesc',
          'reference',
          'receiptNumber'
        ],
        inactive: [
          'jobSiteCode',
          'purchaseOrder',
          'lifexCode'
        ],
        debug: ['documentTypeCode']
      },
      maxColumns: 7
    }
  },
  {
    feature: 'document-center.goods-receipt.table-template-us',
    country: [
      'MX',
      'CO',
      'GB',
      'DE',
      'PA',
      'CR',
      'NI',
      'SV',
      'PR',
      'PE',
      'PH',
      'PL',
      'ES',
      'LV',
      'CZ',
      'FR',
      'EG'
    ],
    options: {
      columns: {
        active: [
          'lifexCode',
          'reference',
          'salesOrder',
          'deliveryDate',
          'jobSiteDesc',
          'POD',
          'receiptNumber'
        ],
        inactive: [
          'jobSiteCode',
          'purchaseOrder',
          'deliveryNumber',
        ],
        debug: ['documentTypeCode']
      },
      maxColumns: 7
    }
  },
  {
    feature: 'document-center.goods-receipt.table-template-gb',
    country: [
      'MX',
      'CO',
      'GB',
      'DE',
      'PA',
      'CR',
      'NI',
      'SV',
      'PR',
      'PE',
      'PH',
      'PL',
      'ES',
      'LV',
      'CZ',
      'FR',
      'EG'
    ],
    options: {
      columns: {
        active: [
          'lifexCode',
          'POD',
          'deliveryDate',
          'salesOrder',
          'jobSiteDesc',
          'reference',
          'receiptNumber',
        ],
        inactive: [
          'deliveryNumber',
          'purchaseOrder',
          'jobSiteCode'
        ],
        debug: ['documentTypeCode']
      },
      maxColumns: 7
    },
  },
  {
    feature: 'document-center.goods-receipt.table-template-de',
    country: [
      'MX',
      'CO',
      'GB',
      'DE',
      'PA',
      'CR',
      'NI',
      'SV',
      'PR',
      'PE',
      'PH',
      'PL',
      'ES',
      'LV',
      'CZ',
      'FR',
      'EG'
    ],
    options: {
      columns: {
        active: [
          'lifexCode',
          'POD',
          'deliveryDate',
          'salesOrder',
          'jobSiteDesc',
          'reference',
          'receiptNumber',
        ],
        inactive: [
          'deliveryNumber',
          'purchaseOrder',
          'jobSiteCode'
        ],
        debug: ['documentTypeCode']
      },
      maxColumns: 7
    },
  },
  {
    feature: 'document-center.goods-receipt.table-template-fr',
    country: [
      'MX',
      'CO',
      'GB',
      'DE',
      'PA',
      'CR',
      'NI',
      'SV',
      'PR',
      'PE',
      'PH',
      'PL',
      'ES',
      'LV',
      'CZ',
      'FR',
      'EG'
    ],
    options: {
      columns: {
        active: [
          'lifexCode',
          'POD',
          'deliveryDate',
          'salesOrder',
          'jobSiteDesc',
          'reference',
          'receiptNumber',
        ],
        inactive: [
          'deliveryNumber',
          'purchaseOrder',
          'jobSiteCode'
        ],
        debug: ['documentTypeCode']
      },
      maxColumns: 7
    }
  },
  {
    feature: 'document-center.goods-receipt.table-template-pl',
    country: [
      'MX',
      'CO',
      'GB',
      'DE',
      'PA',
      'CR',
      'NI',
      'SV',
      'PR',
      'PE',
      'PH',
      'PL',
      'ES',
      'LV',
      'CZ',
      'FR',
      'EG'
    ],
    options: {
      columns: {
        active: [
          'lifexCode',
          'POD',
          'deliveryDate',
          'salesOrder',
          'jobSiteDesc',
          'reference',
          'receiptNumber',
        ],
        inactive: [
          'deliveryNumber',
          'purchaseOrder',
          'jobSiteCode'
        ],
        debug: ['documentTypeCode']
      },
      maxColumns: 7
    }
  },
  {
    feature: 'document-center.goods-receipt.table-template-cz',
    country: [
      'MX',
      'CO',
      'GB',
      'DE',
      'PA',
      'CR',
      'NI',
      'SV',
      'PR',
      'PE',
      'PH',
      'PL',
      'ES',
      'LV',
      'CZ',
      'FR',
      'EG'
    ],
    options: {
      columns: {
        active: [
          'lifexCode',
          'POD',
          'deliveryDate',
          'salesOrder',
          'jobSiteDesc',
          'reference',
          'receiptNumber',
        ],
        inactive: [
          'deliveryNumber',
          'purchaseOrder',
          'jobSiteCode'
        ],
        debug: ['documentTypeCode']
      },
      maxColumns: 7
    }
  },
  {
    feature: 'document-center.goods-receipt.table-template-es',
    country: [
      'MX',
      'CO',
      'GB',
      'DE',
      'PA',
      'CR',
      'NI',
      'SV',
      'PR',
      'PE',
      'PH',
      'PL',
      'ES',
      'LV',
      'CZ',
      'FR',
      'EG'
    ],
    options: {
      columns: {
        active: [
          'lifexCode',
          'POD',
          'deliveryDate',
          'salesOrder',
          'jobSiteDesc',
          'reference',
          'receiptNumber'
        ],
        inactive: [
          'deliveryNumber',
          'purchaseOrder',
          'jobSiteCode'
        ],
        debug: ['documentTypeCode']
      },
      maxColumns: 7
    }
  },
  {
    feature: 'document-center.goods-receipt.table-template-il',
    country: [
      'IL'
    ],
    options: {
      columns: {
        active: [
          'lifexCode',
          'POD',
          'deliveryDate',
          'salesOrder',
          'jobSiteDesc',
          'reference',
          'receiptNumber'
        ],
        inactive: [
          'deliveryNumber',
          'purchaseOrder',
          'jobSiteCode'
        ],
        debug: ['documentTypeCode']
      },
      maxColumns: 7
    }
  },
  {
    feature: "document-center.goods-receipts.table-template.products-v7",
    country: [
      "GB",
      "DE",
      "FR",
      "PL",
      "CZ",
      "ES",
      "IL",
      "AE",
      "UK"
    ],
    options: {
      columns: {
        active: [
          'lifexCode',
          'POD',
          'deliveryDate',
          'products',
          'jobSiteDesc',
          'reference',
          'salesOrder',
        ],
        inactive: [
          'receiptNumber',
          'deliveryNumber',
          'purchaseOrder',
          'jobSiteCode'
        ]
      },
    },
  },
  {
    feature: "document-center.internal-users-staff",
    country: ["US"],
    role: "ARMSTAFFMANCRED",
  },
] as IAppConfiguration[];
